/** Drag-and-drop de URL da biblioteca de mídia → widget Imagem no palco. */

export const GEPPETTO_MEDIA_DRAG_MIME = 'application/x-gepetto-media-url';

export function setGepettoMediaDragData(dataTransfer, url) {
    if (!dataTransfer) return;
    const u = String(url || '').trim();
    if (!u) return;
    try {
        dataTransfer.setData('text/plain', u);
        dataTransfer.setData(GEPPETTO_MEDIA_DRAG_MIME, u);
        dataTransfer.effectAllowed = 'copy';
    } catch (_) {
        /* ignore */
    }
}

export function parseGepettoMediaDropUrl(dataTransfer) {
    if (!dataTransfer || typeof dataTransfer.getData !== 'function') return null;
    const raw =
        dataTransfer.getData(GEPPETTO_MEDIA_DRAG_MIME) ||
        dataTransfer.getData('text/uri-list') ||
        dataTransfer.getData('text/plain') ||
        '';
    const line = String(raw).trim().split(/[\n\r]+/)[0].trim();
    if (!line) return null;
    if (/^https?:\/\//i.test(line)) return line;
    if (line.startsWith('/')) return line;
    return null;
}

/** Durante dragOver: getData costuma estar vazio; usa só types. */
export function dataTransferLooksLikeGepettoMediaUrl(dataTransfer) {
    if (!dataTransfer?.types) return false;
    const types = [...dataTransfer.types];
    if (types.includes('Files')) return false;
    return types.includes(GEPPETTO_MEDIA_DRAG_MIME) || types.includes('text/plain') || types.includes('text/uri-list');
}
